import { combineReducers } from 'redux';
import { reducer as oidcReducer } from 'redux-oidc';

import {
  translationReducer,
  KYCReducers,
  ToolsReducers,
  AuthReducers,
  FormStepsReducer,
  QuestionnaireReducer,
  OnboardingFlowReducer,
  FarmersQuestionnaireReducer
} from '../Services';
import { languageReducer, countryReducer } from '../Local';

export const rootReducer = combineReducers({
  FormStepsReducer,
  translationReducer,
  KYCReducers,
  languageReducer,
  countryReducer,
  ToolsReducers,
  oidcReducer,
  AuthReducers,
  QuestionnaireReducer,
  OnboardingFlowReducer,
  FarmersQuestionnaireReducer
});
